import { CardBarCodeComponent } from './../../../shared/card-barcode/card-barcode.component';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs009-card-I',
    templateUrl: './rs009-card-I.component.html'
})

export class Rs009CardIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listSiteOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listAmostra?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSiteOrigemOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSiteRecebimento?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listSiteRecebimentoOriginal?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public filteredOptionsSiteOrigem: Observable<DropDownListDTO[]>;
    public filteredOptionsSiteRecebimento: Observable<DropDownListSiteRecebimentoDTO[]>;
    public disableBtnCerar: boolean;
    public _scannerIsRunning: boolean;
    public _scannerCerarCode: string;
    public disableCerar: boolean;
    public disableNumeroCampo: boolean = false;
    public safraBasicaOld = ''
    @Output() objMakeCalculations = new EventEmitter();

    @Output() calcDataFromRs005 = new EventEmitter();
    @Output() objMakeCalculationsPreBasica = new EventEmitter();
    @Input() id: number = 0;

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
        super('Etapa 1', false);
        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Cerar: [null, [Validators.required]],
                Lote_rw: [null, [Validators.pattern(this.regexLoteRw)]],
                Cooperante: [null, []],
                Gleba: [null, []],
                Contrato_Juridico: [null, []],
                Produto: [null, []],
                Peso_Amostra: [null, [Validators.max(20000)]],
                Peso_Liquido: [null, []],
                Palha: [null, [Validators.max(20000)]],
                Outras_Sementes: [null, [Validators.max(20000)]],
                Impurezas: [null, [Validators.max(20000)]],
                Site_Origem: [null, []],
                Site_Recebimento: [null, []],
                Safra: [null, [Validators.pattern(this.regexSafra)]],
                Nr_campo: [null, []],
                Umidade: [
                    null,
                    [
                        Validators.required,
                        this.umidadeValidator
                    ]
                ],
            });
        }
        else {
            this.formulario = this.formBuilder.group({
                cerar_basica: [null, [Validators.required]],
                lote_rw: [null, [Validators.pattern(this.regexNewLoteRW), Validators.required]],
                cooperante: [null, [Validators.required]],
                gleba: [null, []],
                geracao: [null, [Validators.required]],
                contrato_juridico: [null, [Validators.required]],
                site_origem: [this.generalService.getLocalStorageDataSite(), [Validators.required]],
                site_recebimento: [this.generalService.getLocalStorageDataSite(), [Validators.required]],
                safra: [null, []],
                safra_basica: [null, [Validators.pattern(this.regexSafraBasica), Validators.required]],
                numero_campo: [null, [Validators.required]],
                hibrido_rnc: [null, [Validators.required]],
                especie: ['Milho', [Validators.required]],
                tipo_colheita: ['Manual', [Validators.required]],
                amostra_seca_molhada: [null, [Validators.required]],
                peso_total_rw: [null, []],
                umidade: [null, [Validators.required]],
            });
        }

    }

    public async ngOnInit(): Promise<void> {
        await this.checkBtnLeitorEnable();
        await this.getQua007Data();
        await this.makeCalculations();
        await this.getListSiteOrigem();
        await this.getListSiteRecebimento();
        await this.getlistAmostra();
        // await this.createFilterSiteOrigem();
        //  await this.createFilterSiteRecebimento();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }
    public makeCalc() {
        this.converterSafra();
        this.getQua007DataPreBasica(null);

    }
    public getQua007DataPreBasica($event) {

        if (this.formulario?.get('safra').value && this.formulario?.get('numero_campo').value) {
            this.formularioService.getQua007Contrato({ safra: this.formulario?.get('safra').value, numero_campo: this.formulario?.get('numero_campo').value }).pipe(take(1)).toPromise().then(result => {
                this.formulario?.get('contrato_juridico').setValue(result.data.contrato_juridico);
                this.formulario?.get('cooperante').setValue(result.data.cooperante);
                this.formulario?.get('geracao').setValue(result.data.geracao);
                this.formulario?.get('hibrido_rnc').setValue(result.data.hibrido_rnc);
            });
        }
        this.getPesoRWFromQua007(null);
        this.getDataFromRs005(null);
    }


    public async getQua007Data(): Promise<void> {
        const cerar = this.formulario.get('Cerar')?.value as string;
        if (!!cerar) {
            await this.formularioService.getQua007Data(cerar).pipe(take(1)).toPromise().then((objQua007: any) => {
                // this.formulario.get('Lote_rw').setValue(objQua007?.data?.lote_rw);
                this.formulario.get('Cooperante').setValue(objQua007?.data?.cooperante);
                this.formulario.get('Gleba').setValue(objQua007?.data?.gleba);
                this.formulario.get('Contrato_Juridico').setValue(objQua007?.data?.contrato_juridico);
                this.formulario.get('Produto').setValue(objQua007?.data?.hibrido_rnc);
                this.formulario.get('Peso_Liquido').setValue(objQua007?.data?.peso_liquido);
                this.formulario.get('Site_Origem').setValue(objQua007?.data?.site_origem);
                this.formulario.get('Site_Recebimento').setValue(objQua007?.data?.site_recebimento);
                this.formulario.get('Safra').setValue(objQua007?.data?.safra);
                this.formulario.get('Nr_campo').setValue(objQua007?.data?.numero_campo);
            }).catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao cerar ${cerar}. Entre em contato com o Administrador.`);
            });
        }
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    async getListSiteOrigem(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'Site_Origem').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listSiteOrigem = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listSiteOrigemOriginal = this.listSiteOrigem;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteOrigem);
        });
    }

    umidadeValidator(control: AbstractControl): ValidationErrors | null {
        const umidade = control.value;
        if (umidade < 5 || umidade > 40) {
            return { invalidUmidade: true };
        }
        return null;
    }

    createFilterSiteOrigem(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listSiteOrigemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listSiteOrigem = this.listSiteOrigemOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listSiteOrigem = this.listSiteOrigemOriginal;
            }
        } else {
            this.listSiteOrigem = this.listSiteOrigemOriginal;
        }

        // this.filteredOptionsSiteOrigem = this.formulario.get('Site_Origem').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listSiteOrigem, value))
        //     );
    }

    async getListSiteRecebimento(): Promise<void> {
        this.listSiteRecebimento = this.generalService.getListSiteRecebimento();
        this.listSiteRecebimentoOriginal = this.listSiteRecebimento;
    }

    createFilterSiteRecebimento(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listSiteRecebimentoOriginal.filter(x => x.initials?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listSiteRecebimento = this.listSiteRecebimentoOriginal.filter(x => x.initials?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listSiteRecebimento = this.listSiteRecebimentoOriginal;
            }
        } else {
            this.listSiteRecebimento = this.listSiteRecebimentoOriginal;
        }

        // this.filteredOptionsSiteRecebimento = this.formulario.get('Site_Recebimento').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listSiteRecebimento, value))
        //     );
    }

    async openDialog(): Promise<void> {
        await this.checkBtnLeitorDisable();
        const dialogRef = this.dialog.open(CardBarCodeComponent, {
            width: '670px',
            height: '700px',
            data: {
                field: 'Cerar',
            }
        });
        dialogRef.afterClosed().subscribe(async data => {
            await this.checkBtnLeitorEnable();
            this.formulario.get('Cerar').setValue(data);
            await this.getQua007Data();
        });
    }

    async checkBtnLeitorDisable(): Promise<void> {
        this.disableBtnCerar = true;
    }

    async checkBtnLeitorEnable(): Promise<void> {
        this.disableBtnCerar = false;
    }

    async checkCerarExist(): Promise<void> {

        if (this.id > 0) {
            return;
        }

        if (!this.disableCerar) {
            const cerar: string = this.formulario.get('Cerar')?.value;

            try {
                await this.formularioService.checkCerarExist(cerar, this.formulario, 'rs009');
            } catch (error) {
                this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar a umidade para o cerar ${cerar}. Entre em contato com o Administrador.`);
            }
        }
    }

    async checkSiteRecebimentoExist(): Promise<void> {

        if (this.id > 0) {
            return;
        }

        if (!this.disableCerar) {
            const siteRecebimento: string = this.formulario.get('Site_recebimento')?.value;

            try {
                await this.formularioService.checkSiteRecebimento(siteRecebimento, this.formulario);
            } catch (error) {
                this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar a umidade para o cerar ${siteRecebimento}. Entre em contato com o Administrador.`);
            }
        }
    }

    converterSafra() {
        const safraBasica = (this.formulario.get('safra_basica')?.value as string)?.toUpperCase()
        const prefix = safraBasica.substring(0, 2); // Pega o prefixo (IN ou VE)
        const year = safraBasica.substring(3); // Pega o ano (22)
        if ((!safraBasica.includes('INV') && !safraBasica.includes('VER'))) {
            this.formulario.get('safra_basica')?.setErrors({ pattern: false })
            this.formulario.get('safra_basica').updateValueAndValidity()

            return
        }
        this.formulario.get('safra')?.setValue(`${prefix}${year}`)


        this.formulario.get('safra_basica')?.setValue(safraBasica)

        this.formulario.get('safra_basica')?.setErrors({ pattern: true })
        this.formulario.get('safra_basica').updateValueAndValidity()

        if (safraBasica != "" || safraBasica != null) {

            this.disableNumeroCampo = this.safraBasicaOld == safraBasica
        }



    }

    async getlistAmostra() {
        await this.formularioService.getListDropDownList('qua007', 'amostra_seca_molhada').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listAmostra = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteOrigem);
        });
    }


    getPesoRWFromQua007($event) {
        if (this.formulario?.get('safra_basica').value &&
            this.formulario?.get('numero_campo').value &&
            this.formulario?.get('cerar_basica').value)
            this.formularioService.getPesoRWFromQua007(
                this.formulario?.get('safra_basica').value,
                this.formulario?.get('numero_campo').value,
                this.formulario?.get('cerar_basica').value).pipe(take(1)).toPromise().then(result => {
                    this.formulario?.get('peso_total_rw').setValue(result.data.peso_total_rw)
                });
    }

    getDataFromRs005($event) {
        this.calcDataFromRs005.emit();
    }


    async checkNumeroCampo() {
        const site = this.formulario.get('site_recebimento')?.value
        const safra = this.formulario.get('safra_basica')?.value
        const numeroCampo = this.formulario.get('numero_campo')?.value
        if (!site || !safra || !numeroCampo || this.disableNumeroCampo) {
            return
        }
        this.formularioService.checkNumeroCampo('rs009', {
            filters: {
                numero_campo: String(numeroCampo),
                site_recebimento: site as string,
                safra_basica: safra as string
            }
        }).pipe(take(1)).toPromise().then((response: any) => {

            if ((response.data as boolean) === true) {
                this.formulario.get('numero_campo').setErrors({ invalidExist: true });;
                this.notificationService.sendNotification(`O Numero do campo ${numeroCampo} já está cadastrado na base de dados, favor inserir outro.`, TypeMessage.Personalized, ActionMessage.Info);
            } else {
                this.formulario.get('numero_campo').setErrors({ invalidExist: false });
                this.formulario.get('numero_campo').updateValueAndValidity();
                this.getQua007DataPreBasica(null)
            }

        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    public makeCalculationsPreBasica($event) {
        this.objMakeCalculationsPreBasica.emit();
    }

}
